import { fontFamily } from "@aix/remotion/src/remotionTemplates/effects/loadFonts"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import AppLayout from "~/layouts/AppLayout"

const EditorLayout = () => {
  return (
    <AppLayout noSidebar style={{ fontFamily: `Inter, ${fontFamily}` }}>
      <Outlet />
    </AppLayout>
  )
}

export const Route = createFileRoute("/videos/$videoId/editor")({
  component: EditorLayout,
})